import { render, staticRenderFns } from "./unresolved.vue?vue&type=template&id=6b0499c8"
import script from "./unresolved.vue?vue&type=script&lang=js"
export * from "./unresolved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports